export const mockAPIPath = {
    SALES_HISTORY: "",
    DUMMY_URL: "",
    SALES_STATEMENT: "./data/SalesStatement.json"
};

export const serverAPIPath = {
    SALES_HISTORY: "/oms/sales/history",
    DUMMY_URL: "/oms/sales/calculation",
    SALES_STATEMENT: "/oms/sales/statement"
};
